import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'lib-reading-instructions',
    templateUrl: './reading-instructions.component.html',
    styleUrls: ['./reading-instructions.component.scss']
})
export class ReadingInstructionsComponent implements OnInit {

    @Input() hideResultWarning = true;
    @Input() text = '';

    constructor() {
    }

    ngOnInit(): void {
    }

}
